export default "__VITE_ASSET__CMTMxL7J__"